<template>
  <v-card style="max-height: 500px" class="box-container ma-0 pa-0">
    <div class="row-header ma-0 pa-0">
      <v-row class="ma-1 pa-0" justify="center" align="center">
        <v-spacer></v-spacer>
        <span class="ma-2 subtitle-1">Избор на колони</span>
        <v-spacer></v-spacer>
        <v-btn color="error" :rounded="true" density="compact" @click="closeThis()" icon="mdi-close"> </v-btn>
      </v-row>
    </div>
    <div class="row-header ma-0 pa-0">
      <v-spacer></v-spacer>
    </div>
    <div class="row-content-limited ma-0 pa-0 customscroll" :style="`height: ${headers.length * 32 + 32}px`">
      <v-switch class="ml-5 my-switch" style="height: 32px" hide-details v-for="(h, idx) in headers" :key="idx" v-model="selected" @change="setVisible(h)" :value="h.value" :label="h.text" :color="Colors.IconColor"></v-switch>
    </div>
  </v-card>
</template>

<script>
import DataManager from "@/data/DataManager";
export default {
  props: {},
  data() {
    return {
      datatype: null,
      selected: [],
      headers: [],
    };
  },
  methods: {
    closeThis() {
      try {
        if (!DataManager.user.ColumnSettings[this.datatype.path]) {
          DataManager.user.ColumnSettings[this.datatype.path] = {};
        }
        this.datatype.headers.forEach((h) => {
          DataManager.user.ColumnSettings[this.datatype.path][h.value] = h.hidden;
        });

        DataManager.updateUserSettings(() => {});
      } catch (ex) {
        // console.log(ex);
        //ignored
      }
      this.dialog.close();
    },
    setVisible(h) {
      return (h.hidden = !h.hidden);
    },
  },
  computed: {},
  created() {
    this.datatype = this.dialog.data;
    this.headers = this.datatype.headers.filter((h) => h.isInSelector);
    this.selected = this.headers.filter((f) => !f.hidden).map((h) => h.value);
  },
  beforeUnmount() {},
  watch: {
    selected: function (newVal, oldVal) {
      this.headers.forEach((f) => {
        if (oldVal.indexOf(f) !== -1) {
          f.hidden = false;
        }
      });
    },
  },
};
</script>

<style>
.v--modal-background-click {
  backdrop-filter: blur(3px);
}
.size-modal-content {
  padding: 10px;
  font-style: 12px;
}
.v--modal-overlay[data-modal="size-modal"] {
  background: rgba(0, 0, 0, 0.5);
}
.demo-modal-class {
  border: 1px solid #d84315;
  border-radius: 5px;
  /* background: #F7F7F7; */
  box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
}
</style>
<style scoped>
h3 {
  background: gray;
  cursor: move;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}

.my-switch >>> label {
  font-size: 14px;
}

.light {
  background: #f7f7f7;
  color: black;
}
.dark {
  background: black;
  color: #f7f7f7;
}
</style>
@/data/DataManager